import React, { CSSProperties, useEffect, useRef } from 'react';
import QRCodeStyling from 'qr-code-styling';

interface QrCodeProps {
  url: string;
  size?: number;
  icon?: string;
  style?: CSSProperties;
}

export const QrCode = (props: QrCodeProps): JSX.Element => {
  const qrCodeRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const generateQrCode = async (): Promise<void> => {
      const url = new URL(props.url);
      const qrCode = new QRCodeStyling({
        width: props.size ?? 200,
        height: props.size ?? 200,
        image: props.icon ?? 'assets/parentPortal/mobile.svg',
        type: 'svg',
        margin: 10,
        dotsOptions: {
          color: '#ff8429',
          type: 'extra-rounded',
        },
        imageOptions: {
          crossOrigin: 'anonymous',
          margin: 3,
          imageSize: 0.5,
        },
        qrOptions: {
          errorCorrectionLevel: 'H',
        },
        cornersSquareOptions: {
          type: 'extra-rounded',
        },
      });

      qrCode.update({ data: url.href });

      if (qrCodeRef.current) {
        qrCodeRef.current.innerHTML = '';
        qrCode.append(qrCodeRef.current);
      }
    };

    void generateQrCode();
  }, [props.url]);

  return (
    <div
      ref={qrCodeRef}
      style={{ ...props.style, borderRadius: 20, overflow: 'hidden' }}
    />
  );
};
